import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createBlock as _createBlock, renderList as _renderList, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = {
  class: "box mt-4",
  style: {"width":"100%"}
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { style: {"color":"#00d1c7ff !important"} }

import { computed, defineComponent, onMounted, onUnmounted, reactive, ref, watch } from "vue";
import { useRouter } from "vue-router";
import request from "../../common/request";
import { transformDate, transformDate2, transformDate3, getRealFactoryIdList } from "../../common/tools";
import { v4 as uuidv4 } from "uuid";
import { Dayjs } from 'dayjs';
import { langList } from "../../common/lang";
import { getFactoryName, transformBeiJingDate, transformLocalDate } from "../../common/tools";
import { getLanguage, getTranslation, getChineseFt } from "@/common/translate"
import { message } from 'ant-design-vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'WeekReport',
  setup(__props) {

let langObj: any = ref({})
let language: any = ref('English')
const getLang = () => {
     language.value = 'English'
    langObj.value = langList[language.value]
}
getLang();

const router = useRouter();
const pagination = computed(() => ({
  total: searchModel.value.total,
  current: searchModel.value.skip,
  pageSize: searchModel.value.take,
}));
let searchModel:any = ref({
    date: null,
    type: null,
    total: 0,
    skip: 1,
    take: 10,
    sort: 'date',
    order: -1
})
const columns = [
    {
        title: langObj.value['报告周期'],
        dataIndex: 'cycle',
    },
    {
        title: langObj.value['报告标题'],
        dataIndex: 'title',
    },
    {
        title: langObj.value['报告类型'],
        dataIndex: 'type',
    },
    {
        title: langObj.value['健康设备']+'（台）',
        dataIndex: 'count1',
    },
    {
        title: langObj.value['可用设备']+'（台）',
        dataIndex: 'count2',
    },
    {
        title: langObj.value['警戒设备']+'（台）',
        dataIndex: 'count3',
    },
    {
        title: langObj.value['故障设备']+'（台）',
        dataIndex: 'count4',
    },
    {
        title: langObj.value['分析周期'],
        dataIndex: 'cycle2',
    },
    {
        title: langObj.value['报告时间'],
        dataIndex: 'date',
    },
    {
        title: langObj.value['操作'],
        dataIndex: 'act',
    },
]
let typeList = [
    {label: '周报', value: 3},
    {label: '月报', value: 4},
]
let data:any = ref([])

onMounted(() => {
    init()
})

const init = () => {
    getAdmin()
    search()
}

let admin = ref(false)
const getAdmin = () => {
    let member = JSON.parse(localStorage.getItem('memberInfo') || '')
    admin.value = member?.admin
}


const search = () => {
    searchModel.value.skip = 1
    getData()
}

const reset = () => {
    searchModel.value = {
        ...searchModel.value,
        date: null,
        type: null,
    }
}

const getData = async() => {
    let type = searchModel.value.type ? [searchModel.value.type] : [3, 4]
    let config: any = {
        params: {
            skip: searchModel.value.skip,
            take: searchModel.value.take,
            type,
            sort: searchModel.value.sort,
            order: searchModel.value.order,
            factoryIds: getRealFactoryIdList(),
        },
        headers: {
            requestId: uuidv4(),
        },
    };

    if (searchModel.value.date && searchModel.value.date.length === 2) {
        config.params.begin = transformBeiJingDate(transformDate2(new Date(searchModel.value.date[0]), 1));
        config.params.end = transformBeiJingDate(transformDate2(new Date(searchModel.value.date[1]), 2));
    }

    let result = await request.get('/api/external/reports', config)
    console.log('result', result)

    if(result && result.status === 200) {
        result.data.list.map((d:any) => {
            let count1 = 0, count2 = 0, count3 = 0, count4 = 0
            d.weekReport && d.weekReport.map((i:any) => {
                if(i.status === '故障') {
                    count4 ++
                }
                if(i.status === '警戒') {
                    count3 ++
                }
                if(i.status === '可用') {
                    count2 ++
                }
                if(i.status === '健康') {
                    count1 ++
                }
            })

            d.monthReport && d.monthReport.map((i:any) => {
                if(i.status === '故障') {
                    count4 ++
                }
                if(i.status === '警戒') {
                    count3 ++
                }
                if(i.status === '可用') {
                    count2 ++
                }
                if(i.status === '健康') {
                    count1 ++
                }
            })

            d.count1 = count1
            d.count2 = count2
            d.count3 = count3
            d.count4 = count4

            if(d.title.includes('周报')) {
                if(language.value === 'English') {
                    let lanL = d.title.split('周报')
                    d.title = getTranslation(lanL[0]) + ' weekly report'
                }
            }

            if(d.title.includes('月报')) {
                if(language.value === 'English') {
                    let lanL = d.title.split('月报')
                    d.title = getTranslation(lanL[0]) + ' monthly report'
                }
            }
        })


        data.value = result.data.list
        searchModel.value.total = result.data.count
    }
}

const details = (ev:any) => {
    router.push('/report/mwDetail/' + ev.id)
}



const handleTableChange = (pagination: any, filters: any, sorter: any) => {
  // 处理分页数据
  if(Object.keys(sorter).length) { 
    var order = sorter.order ? (sorter.order == "descend" ? -1 : 1) : 0;
    searchModel.value.sort = sorter.field
    searchModel.value.order = order
  }
  // 处理分页数据
  searchModel.value.skip = pagination.current
  searchModel.value.take = pagination.pageSize
  getData();
};

const getDate = (date: any) => {
  date = new Date(date)
  let year = date.getFullYear()
  let month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)
//   let w = date.getDay(),
//     d = date.getDate();
//   if (w == 0) {
//     w = 7;
//   }

    const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    
    // 计算当前日期与月初的毫秒差
    const diffInMs = date - firstDayOfMonth;
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
    
    // 获取当月第一天是星期几
    const firstDayOfWeek = firstDayOfMonth.getDay();
    
    // 调整周数计算（假设周一为一周的第一天）
    const weekNumber = Math.ceil((diffInDays + firstDayOfWeek) / 7);



  if(language.value == 'Chinese') {
    return year + '年' + month + '月' + ' ' + '第' + weekNumber + '周'
  } else if(language.value == 'English') {
    let monList = [
        {label: 'January', value: '01'},
        {label: 'February', value: '02'},
        {label: 'March', value: '03'},
        {label: 'April', value: '04'},
        {label: 'May', value: '05'},
        {label: 'June', value: '06'},
        {label: 'July', value: '07'},
        {label: 'August', value: '08'},
        {label: 'January', value: '09'},
        {label: 'October', value: '10'},
        {label: 'November', value: '11'},
        {label: 'December', value: '12'},
    ]
    return monList.find((p:any) => p.value == month)?.label + ' ' + year + ',' + 'Week' + weekNumber
  } else {
    let a = year + '年' + month + '月' + ' ' + '第' + weekNumber + '周'
    return getChineseFt(a)
  }

  
}

const getDate2 = (ev:any, type:any) => {
    let day = type === 3 ? 7 : 30
    let date = new Date(ev).getTime() - (1000 * 60 * 60 * 24 * day)
    let begin = transformDate3(new Date(date))
    return begin + ' ~ ' + transformDate3(ev)
}

const getRowClassName = (record:any, index:any) => {
    // 根据索引设置不同的类名
    return index % 2 === 0 ? 'even-row' : 'odd-row';
}

const dates = ref<any>();

const disabledDate = (current: Dayjs) => {
  if (!dates.value || (dates.value as any).length === 0) {
    return false;
  }
  const tooLate = dates.value[0] && current.diff(dates.value[0], 'days') > 30;
  const tooEarly = dates.value[1] && dates.value[1].diff(current, 'days') > 30;
  return tooEarly || tooLate;
};

const onCalendarChange = (val: any) => {
  dates.value = val;
};

const deleteReport = async(ev:any) => {
    const config = {
        params: {
            id: ev.id
        },
        headers: {
            requestId: uuidv4(),
        },
    };

    let result = await request.delete('/api/reports/info', config)
    if (result?.data) {
        message.success(getLanguage("操作成功"));
        getData();
    } else {
        message.warning("操作失败");
    }
}


// 新增报告
let visible = ref(false)
let form:any = ref({
    type: 3,
    date: null
})

const add = () => {
    form.value = {
        type: 3,
        date: null,
        factoryId: localStorage.getItem('factory_id')
    } 
    visible.value = true
}

const sumit = async() => {
    console.log('form', form.value)//transformDate
    if(!form.value.factoryId) {
        return message.warning('请选择工厂后提交!')
    }
    if(!form.value.date) {
        return message.warning('请选择生成时间后提交!')
    }


    let sub = {
        type: form.value.type,
        factoryId: form.value.factoryId,
        date: transformDate(form.value.date)
    }

    let result = await request.post('/api/reports/week', sub)
}



return (_ctx: any,_cache: any) => {
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_a_form, {
        model: _unref(searchModel),
        name: "horizontal_login",
        layout: "inline",
        autocomplete: "off"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            label: _unref(langObj)['提交时间'],
            name: "status"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_range_picker, {
                value: _unref(searchModel).date,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchModel).date) = $event)),
                "disabled-date": disabledDate,
                onCalendarChange: onCalendarChange
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", {
                  onClick: reset,
                  class: "btn px-5 py-1 fff cursor-pointer ml-4"
                }, _toDisplayString(_unref(langObj)['重置']), 1),
                _createElementVNode("div", {
                  onClick: search,
                  class: "btn px-5 py-1 fff cursor-pointer ml-4",
                  style: {"background-color":"#171325ff"}
                }, _toDisplayString(_unref(langObj)['查询']), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_a_table, {
        style: {"width":"100%"},
        size: "small",
        "row-class-name": getRowClassName,
        columns: columns,
        "data-source": _unref(data),
        pagination: pagination.value,
        onChange: handleTableChange
      }, {
        bodyCell: _withCtx(({ column, text, record }) => [
          (column.dataIndex === 'cycle')
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(getDate(record.date)), 1))
            : _createCommentVNode("", true),
          (column.dataIndex === 'cycle2')
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(getDate2(record.date, record.type)), 1))
            : _createCommentVNode("", true),
          (column.dataIndex === 'type')
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(text == 3 ? _unref(langObj)['周报'] : _unref(langObj)['月报']), 1))
            : _createCommentVNode("", true),
          (column.dataIndex === 'date')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createTextVNode(_toDisplayString(_unref(transformLocalDate)(text)), 1)
              ], 64))
            : _createCommentVNode("", true),
          (column.dataIndex === 'act')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _createElementVNode("a", {
                  onClick: ($event: any) => (details(record)),
                  style: {"color":"#00d1c7ff !important"}
                }, _toDisplayString(_unref(langObj)['查看详情']), 9, _hoisted_7),
                _createVNode(_component_a_divider, { type: "vertical" }),
                (_unref(admin))
                  ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                      key: 0,
                      title: _unref(langObj)['确认删除']+'?',
                      "ok-text": _unref(langObj)['确认'],
                      "cancel-text": _unref(langObj)['取消'],
                      onConfirm: ($event: any) => (deleteReport(record))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("a", _hoisted_8, _toDisplayString(_unref(langObj)['删除']), 1)
                      ]),
                      _: 2
                    }, 1032, ["title", "ok-text", "cancel-text", "onConfirm"]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["data-source", "pagination"])
    ]),
    _createVNode(_component_a_modal, {
      visible: _unref(visible),
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (_isRef(visible) ? (visible).value = $event : visible = $event)),
      width: "800px",
      title: "新增周报",
      maskClosable: false,
      onOk: sumit
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: _unref(form),
          autocomplete: "off",
          "label-col": { style: { width: '150px' } }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "报告类型",
              name: "type",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: _unref(form).type,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).type) = $event)),
                  style: {"width":"220px"},
                  placeholder: "请选择报告类型"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(typeList), (item, index) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: index,
                        value: item.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "生成时间",
              name: "date",
              allowClear: false,
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_date_picker, {
                  "show-time": "",
                  value: _unref(form).date,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).date) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})